
export class CheckPassword {
  code: string;
  corporateId: string;
  propertyId: string | null;
}
